import { HHTextField } from '@hinge-health/react-component-library';
import { Controller, useFormContext } from 'react-hook-form';
import {
  fieldHasErrors,
  getFormErrorsForContractField,
} from '../../../../utils/contract-utils';
import { ContractPackageFormLabelText } from '../form';

export interface GlobalDailyEngagementCapProps {
  wholeFormDisabled: boolean | undefined;
}

export const GLOBAL_DAILY_ENGAGEMENT_CAP_TEST_ID =
  'global-daily-engagement-cap-test-id';

export const GlobalDailyEngagementCap = ({
  wholeFormDisabled,
}: GlobalDailyEngagementCapProps): JSX.Element => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      name="globalDailyEngagementCap"
      render={({ field: { onChange, value } }): JSX.Element => (
        <HHTextField
          data-testid={GLOBAL_DAILY_ENGAGEMENT_CAP_TEST_ID}
          hhVariant="variant-bypass"
          label={ContractPackageFormLabelText.GLOBAL_DAILY_ENGAGEMENT_CAP}
          fullWidth
          disabled={wholeFormDisabled}
          error={fieldHasErrors('globalDailyEngagementCap', errors)}
          helperText={getFormErrorsForContractField(
            'globalDailyEngagementCap',
            errors,
          )}
          value={value ?? ''}
          onChange={onChange}
          type="number"
        />
      )}
    />
  );
};
